import { ProductBannerContainer } from './ProductBanner.style';
import LogoTegor from '../../assets/Lines/white-logos/tegor-blanco.png';
import LogoReckeweg from '../../assets/Products/Logos/dr-reckeweg-white.png';
import LogoHelixor from '../../assets/Lines/white-logos/helixor-blanco.png';
import LogoSymbiopharm from '../../assets/Lines/white-logos/symbio-blanco.png';
import LogoRegenhial from '../../assets/Lines/white-logos/regenhial-blanco.png';

const logoMap = {
    tegor: LogoTegor,
    'dr-reckeweg': LogoReckeweg,
    helixor: LogoHelixor,
    'symbio-pharm': LogoSymbiopharm,
    regenhial: LogoRegenhial
};

const ProductBanner = ({ lineId }) => {
    const logo = logoMap[lineId] || LogoReckeweg; // Default to Reckeweg if lineId is not found

    return (
        <ProductBannerContainer lineId={lineId}>
            <img src={logo} alt={`${lineId} Logo`} />
        </ProductBannerContainer>
    );
}

export default ProductBanner;
